import { useCallback, useMemo } from 'react'

import { useFlags } from '@/feature/feature-flags'
import { useIsSubbie } from '@/feature/subbies/hooks/useIsSubbie'

import { navItems } from './navItems'
import { NavItem } from './SidebarNav.types'
import { isNavItemNavigable, resolveNavItems } from './SidebarNav.utils'

/**
 * Resolves the navigation config against the current user's feature flags.
 * Every consumer of the navigation must go through this hook so the sidebar and
 * the command palette can never expose different sets of pages.
 */
export const useNavItems = () => {
  const flags = useFlags()
  const isSubbie = useIsSubbie()

  const visibleItems = useMemo(() => resolveNavItems(navItems, flags, isSubbie), [flags, isSubbie])

  const navigableItems = useMemo(
    () => visibleItems.filter((item) => !item.isBlocked),
    [visibleItems],
  )

  const canNavigateTo = useCallback(
    (item: NavItem) => isNavItemNavigable(item, flags, isSubbie),
    [flags, isSubbie],
  )

  return { visibleItems, navigableItems, canNavigateTo }
}
